import api from './interceptor';

const BASE_URL_V2 = 'api/v2/rpm-message';

export default {
  // API Version 2
  sendSms: (patientId, params) => api.post(`${BASE_URL_V2}/sms/${patientId}`, params),
  sendEmail: (patientId, params) => api.post(`${BASE_URL_V2}/email/${patientId}`, params),
};
